<template>
  <v-container class="table-card">
    <v-card>
      <v-card-title class="headline font-weight-regular blue-grey white--text">
        Inventory
      </v-card-title>
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
          class="pr-3 pl-3"
        ></v-text-field>
      </v-card-title>
      <div class="pa-4">
        <v-data-table
          :headers="headers"
          :items="foods"
          :loading="loading"
          item-key="id"
          :search="search"
          :pagination.sync="pagination"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <!-- <td>{{ props.item.name }}</td> -->
              <td>
                <v-edit-dialog
                  :return-value.sync="props.item.name"
                  lazy
                  @save="save"
                  @cancel="cancel"
                  @open="open"
                  @close="close"
                >
                  {{ props.item.name }}
                  <v-text-field
                    slot="input"
                    v-model="props.item.name"
                    :rules="[max75chars]"
                    label="Edit"
                    single-line
                    counter
                  ></v-text-field>
                </v-edit-dialog>
              </td>
              <td class="text-xs-center">{{ props.item.serving }} {{ props.item.unit }}</td>
              <td class="text-xs-center">{{ props.item.net }} {{ props.item.unit }}</td>
              <td class="text-xs-center">{{ props.item.inventory }} {{ props.item.unit }}</td>
              <td class="text-xs-center">
                <v-icon
                  small
                  class="mr-2"
                  @click="addItem(props.item)"
                >
                  add
                </v-icon>
                <v-icon
                  small
                  class="mr-2"
                  @click="restockItem(props.item)"
                >
                  repeat
                </v-icon>
                <v-icon
                  small
                  class="mr-2"
                  @click="eatItem(props.item)"
                >
                  restaurant
                </v-icon>
                <v-icon
                  small
                  @click="outOfStockItem(props.item)"
                >
                  close
                </v-icon>
              </td>
            </tr>
          </template>
          <v-alert slot="no-results" :value="true" color="error" icon="warning">
            Your search for "{{ search }}" found no results.
          </v-alert>
        </v-data-table>
      </div>
    </v-card>
    <v-snackbar v-model="snack" :timeout="3000" :color="snackColor">
      {{ snackText }}
      <v-btn flat @click="snack = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import db from '@/firebase/firestore'
export default {
  name: "Inventory",
  data() {
    return {
      loading: true,
      foods: [],
      search: '',
      headers: [
        { text: 'Item Name', value: 'name' },
        { text: 'Serving', value: 'serving' },
        { text: 'Net', value: 'net' },
        { text: 'Inventory', value: 'inventory' },
        { text: 'Action', value: 'action' }
      ],
      pagination: {
        //descending: boolean,
        //page: number,
        rowsPerPage: -1, // -1 for All
        //sortBy: string,
        // totalItems: number
      },
      max75chars: v => v.length <= 75 || 'Input too long!',
      snack: false,
      snackColor: '',
      snackText: '',
    }
  },
  created() {
    // ---------------------- Load Foods
    let ref = db.collection('food')
    ref.get().then((snapshot) => {
      this.loading = false
      snapshot.forEach( doc => {
        let food = doc.data()
        food.id = doc.id
        food.portion = Math.round( (food.net/food.serving) * 100 ) / 100
        food.inventory = food.inventory ? food.inventory : 0
        this.foods.push( food )
      })
    })
  },
  methods: {
    save () {
      this.snack = true
      this.snackColor = 'success'
      this.snackText = 'Data saved'
    },
    cancel () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Canceled'
    },
    open () {
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Dialog opened'
    },
    close () {
      console.log('Dialog closed')
    },
    addItem( item ) {
      item.inventory = parseFloat(item.inventory) + parseFloat(item.net)
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Added Item'
      this.saveItem(item)
    },
    restockItem( item ) {
      item.inventory = item.net
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Restocked Item'
      this.saveItem(item)
    },
    eatItem( item ) {
      item.inventory = Math.round((parseFloat(item.inventory) - parseFloat(item.serving))*100)/100
      if( item.inventory < 0 ) item.inventory = 0
      this.snack = true
      this.snackColor = 'info'
      this.snackText = 'Consumed Serving'
      this.saveItem(item)
    },
    outOfStockItem( item ) {
      item.inventory = 0
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Item Out of Stock'
      this.saveItem(item)
    },
    saveItem( item ) {
      // console.log('item',item)
      let ref = db.collection('food')
      ref.doc(item.id).set(item).then(() => {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Record Saved!'
      })
    }
  }
}
</script>

<style>

</style>
